<template>
  <div class="chat-messages">
    <div class="chat">
      <div class="chat-parent">
        <div class="chat-content clearfix" id="chatContent">
          <span 
            v-for="(msg, index) of msgs"
            :key="index"
            :class="`${msg.you ? 'you' : 'friend'} ${msg.first ? 'first' : ''} ${msg.last ? 'last' : ''}`" >
            {{ msg.msg }}
            <span class="time">
              {{ msg.sTime }}
            </span>
          </span>
          <span class="empty">
            END
          </span>
        </div>
      </div>
      <div class="msg-box">
        <v-text-field
          :placeholder="$t('messages.typeSomething', locale)" 
          v-model="message"
          solo
          flat
          hide-details
          append-icon="mdi-send"
          @click:append="handleSend"
          v-on:keyup.enter="handleSend"
        />
        <!--input type="text" class="ip-msg" 
        :placeholder="$t('messages.typeSomething', locale)" v-model="message" />
        <span class="btn-group" @click="handleSend">
          <v-icon>mdi-send</v-icon>
        </span-->
      </div>
    </div>
  </div>
</template>
<script>
import apiMessages from '@/services/apiMessages'
export default {
  props: {
    locale: {
      type: String,
      required: true,
    },
    onDisconnect: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    message: null,
    msgs: [],
  }),
  computed: {
    msgs_ () {
      return [
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: false,
        last: true,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: true,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: true,
        first: false,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: true,
        first: false,
        last: true,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      {
        you: false,
        first: true,
        last: false,
        msg: 'Hi, How are You?',
        sTime: '7:30 PM',
      },
      ]
    },
  },
  mounted () {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom () {
      const objDiv = document.getElementById('chatContent')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    handleSend () {
      this.handleAddMessage(this.message, true)
      apiMessages.sendMessage({ message: this.message, locale: this.locale })
        .then(response => {
          alert(response)
          console.log('response', response)
          this.message = ''
        })
        .catch (error => {
          this.message = ''
          this.onDisconnect()
          alert(this.$t('messages.sessionNotfound', this.locale))
        })
    },
    handleAddMessage (msg, you) {
      this.msgs.push({
        you,
        first: true,
        last: false,
        msg,
        sTime: '7:30 PM',
      })
    },
  },
}
</script>
<style>
/*
*
{
  margin: 0;
  padding: 0;
  outline: none;
}

body
{
  font-family: 'Roboto', sans-serif;
  background: #c1b4ff;
}

.container
{
  position: relative;
  width: 430px;
  height: 900px;
  left: 50%;
  margin: 0px auto;
  margin-left: -205px;
  display: inline-block;
}

div.app
{
  position: relative;
  width: 380px;
  height: 670px;
  background: #5850c0;
  margin-top: 30px;
}

div.app:before
{
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 100px;
  display: inline-block;
  box-shadow: inset 0 80px 85px -35px #3c33b0;
  z-index: 0;
}

div.app:after
{
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 100px;
  display: inline-block;
  bottom: 0;
  box-shadow: inset 0 -80px 85px -35px #3c33b0;
  z-index: 0;
}

div.app div.head
{
  z-index: 1;
  position: relative;
  display: block;
  width: 100%;
  height: 50px;
  line-height: 48px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: rgba(255,255,255,0.7);

  background: #271c5d;
  border-bottom: 1px solid rgba(255,255,255,0.35);
  box-shadow: inset 0 -15px 35px -5px rgba(0,0,0,0.3);
}

div.head span.title
{
  position: absolute;
  width: 100%;
  display: inline-block;
  left: 0;
  font-size: 16px;
  font-weight: 500;
  margin-top: 2px;
  color: #fff;
}
div.head span.messages-notification
{
  position: relative;
  float: left;
  font-size: 18px;
  font-weight: normal;
  margin-left: 15px;
  color: #fff;
  margin-top: 2px;
}

div.head span.messages-notification span.count
{
  position: absolute;
  font-size: 10px;
  width: 17px;
  height: 17px;
  display: inline-block;
  background: #f42052;
  line-height: 17px;
  border-radius: 100%;
  margin-top: 6px;
  margin-left: -10px;
}

div.head span.create-new
{
  float: right;
  font-size: 17px;
  font-weight: normal;
  margin-right: 15px;
  color: #fff;
  margin-top: 2px;
}

.clearfix::after
{
  content: '';
  clear: both;
  display: table;
}

div.search-bar
{
  position: relative;
  margin-top: 15px;
  text-align: center;
  z-index: 1;
}

div.search-bar .ip-search
{
  width: 85%;
  border: none;
  font-size: 16px;
  padding: 10px 15px;
  color: rgba(255,255,255,0.7);
  background: rgba(255,255,255,0.25);
  border-radius: 50px;
  border: 1px solid rgba(60,51,176,0.7);
  box-shadow: inset 0 25px 25px -15px rgba(60,51,176,0.15);
}

div.search-bar .ip-search::placeholder
{
  color: rgba(255,255,255,0.8);
  letter-spacing: 1px;
  font-size: 14px;
}

div.search-bar i.fa
{
  position: absolute;
  right: 0;
  margin-right: 25px;
  margin-top: 14px;
  color: rgba(255,255,255,0.8);
  font-size: 12px;
}

.friend-list
{
  margin-top: 35px;
}

.friend-list ul li
{
  position: relative;
  list-style: none;
  float: left;
  width: 20%;
  text-align: center;
}

.friend-list ul li img
{
  border-radius: 100%;
  border: 3px solid rgba(255,255,255,1);
}

.friend-list ul li:nth-child(2n+1) img
{
  width: 40px;
  height: 40px;
}

.friend-list ul li:nth-child(2n+2) img
{
  width: 50px;
  height: 50px;
  transform: translateY(-10%);
}

.friend-list ul li:nth-child(3) img
{
  width: 70px;
  height: 70px;
  transform: translateY(-20%);
}

.friend-list ul li:nth-child(2n+1) img,
.friend-list ul li:nth-child(2n+1) span.name
{
  opacity: 0.4;
}

.friend-list ul li:nth-child(2n+2) img,
.friend-list ul li:nth-child(2n+2) span.name
{
  opacity: 0.7;
}

.friend-list ul li.active img,
.friend-list ul li.active span.name
{
  opacity: 1;
}

.friend-list ul li.active img
{
  box-shadow: 1px 1px 0 rgba(39,28,93,0.5),
              -1px -1px 0 rgba(39,28,93,0.5),
              0 0 35px rgba(255,255,255,0.3);
}

.friend-list ul li span.name
{
  position: relative;
  width: 100%;
  left: 0;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(255,255,255,0.9);
}

.friend-list ul li.active span.name
{
  top: -7px;
}

.friend-list ul li span.name span.status
{
  display: block;
  text-transform: none;
  font-weight: 300;
  font-size: 8px;
  color: rgba(255,255,255,0.5);
}

.friend-list ul li.active span.name span.status
{
  font-size: 9px;
}

.friend-list ul li:nth-child(2n+1) span.messages span.count
{
  position: absolute;
  font-size: 10px;
  width: 17px;
  height: 17px;
  display: inline-block;
  background: #f42052;
  z-index: 10;
  line-height: 17px;
  border-radius: 100%;
  margin-top: -2px;
  right: 0;
  margin-right: 10px;
  color: #fff;
}

.friend-list ul li:nth-child(2n+2) span.messages span.count
{
  position: absolute;
  z-index: 10;
  font-size: 10px;
  width: 20px;
  height: 20px;
  display: inline-block;
  background: #f42052;
  line-height: 20px;
  border-radius: 100%;
  margin-top: -10px;
  right: 0;
  margin-right: 7px;
  color: #fff;
}

.friend-list ul li.active span.messages,
.friend-list ul li span.messages.hide
{
  display: none;
}
*/

.chat-parent {
  width: 100%;
  height: calc(100vh - 75px) !important;
  overflow: hidden;
}
.chat-content {
  /*width: 100%;*/
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
  box-sizing: content-box; /* So the width will be 100% + 17px */
  padding: 10px;
}

div.chat-messages
{
  position: relative;
  margin-top: 15px;
  z-index: 10;
}

div.chat-messages div.chat
{
  position: relative;
  background: #fcfcfe;
  border-radius: 5px;
  font-size: 15px;
}

div.chat div.chat-content > span
{
  margin-bottom: 12px;
}

div.chat div.chat-content span.friend
{
  position: relative;
  width: 70%;
  height: auto;
  display: inline-block;
  background: #fff;
  padding: 10px;
  padding-bottom: 25px;
  box-shadow: 2px 2px 20px -2px rgba(60,51,176,0.2);
  color: rgba(60,51,176,1);
}

div.chat div.chat-content span.friend.first
{
  border-radius: 15px 15px 15px 2px;
}

div.chat div.chat-content span.friend.last
{
  border-radius: 2px 15px 15px 15px;
}

div.chat div.chat-content span.friend span.time
{
  position: absolute;
  display: block;
  right: 0;
  margin-top: 5px;
  margin-right: 10px;
  font-size: 10px;
  font-weight: 500;
  color: rgba(60,51,176,0.5);
}

div.chat div.chat-content span.you
{
  position: relative;
  float: right;
  width: 70%;
  height: auto;
  background: #5850c0;
  display: inline-block;
  padding: 10px;
  padding-bottom: 25px;
  color: #fff;

  box-shadow: 2px 2px 20px rgba(60,51,176,0.2),
              inset -10px -10px 55px rgba(255,255,255,0.1);
}

div.chat div.chat-content span.you span.time
{
  position: absolute;
  display: block;
  right: 0;
  margin-top: 5px;
  margin-right: 10px;
  font-size: 10px;
  font-weight: 500;
  color: rgba(255,255,255,0.5);
}

div.chat div.chat-content span.you.first
{
  border-radius: 15px 15px 2px 15px;
}

div.chat div.chat-content span.you.last
{
  border-radius: 15px 2px 15px 15px;
}

div.chat div.chat-content span.empty
{
  position: relative;
  float: right;
  width: 70%;
  height: auto;
  background: white;
  display: inline-block;
  padding: 10px;
  padding-bottom: 15px;
  color: white;

}

div.msg-box
{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  border-top: 1px solid rgba(60,51,176,0.1);
  overflow: hidden;
  background-color: white;
}

div.msg-box .ip-msg
{
  width: 80%;
  font-size: 14px;
  padding: 15px;
  padding-right: 10px;
  color: rgba(60,51,176,0.9);
  border: none;
  background: rgba(0,0,0,0.03);
}

div.msg-box .ip-msg::placeholder
{
  color: rgba(60,51,176,0.4);
}

div.msg-box span.btn-group
{
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 14px;
  display: inline-block;
  margin-right: 10px;
}

div.msg-box span.btn-group i
{
  color: rgba(60,51,176,1);
  font-size: 18px;
  padding: 0 7px;
}

div.footer
{
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 10;
  background: #271c5d;
  border-top: 1px solid rgba(255,255,255,0.35);
  box-shadow: inset 0 15px 25px -5px rgba(0,0,0,0.3);
}

div.footer ul li
{
  list-style: none;
  float: left;
  width: 20%;
  display: inline-block;
  padding: 18px 0;
  font-size: 18px;
  text-align: center;
  color: #8b86ed;
}

div.footer ul li.active
{
  color: #fff;
  box-shadow: inset 0 -6px 0 rgba(139,134,237,0.8),
              inset 0 -25px 25px -10px rgba(139,134,237,0.2);
}








.yt {
  position: fixed;
  padding: 7px 10px 3px 10px;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 7px;
}

.yt:hover {
  background: rgba(0, 0, 0, 0.4);
}
</style>

